import { InlineNotification } from '@carbon/react';
import { GeometryPriority } from 'components/geometry-priority/geometry-priority';
import type { ScenarioDetailsSectionProps } from './types';
import styles from './scenario-details-section.module.scss';

/**
 * Shared "Scenario Details" panel for all scenario form types.
 * Two-column layout: left column is user-defined fields (via children),
 * right column is the Geometry Priority reorderable list.
 * Shows an optional "name required" warning at the top.
 * @param {ScenarioDetailsSectionProps} props - The component props
 * @return {JSX.Element} The scenario details section
 */
export function ScenarioDetailsSection({
  geometryPriorityItems,
  onGeometryPriorityChange,
  showNameWarning = false,
  warningText = 'A scenario must have a name before it can be saved.',
  children,
}: ScenarioDetailsSectionProps): JSX.Element {
  return (
    <div className={styles.scenarioDetails}>
      {showNameWarning && (
        <InlineNotification
          kind="warning"
          lowContrast
          hideCloseButton
          title="Name required"
          subtitle={warningText}
        />
      )}

      <div className={styles.twoColumn}>
        <div className={styles.leftCol}>{children}</div>
        <div className={styles.rightCol}>
          <GeometryPriority
            items={geometryPriorityItems}
            onChange={onGeometryPriorityChange}
          />
        </div>
      </div>
    </div>
  );
}
